<div class="p-24" [ngClass]="{'warningmessage':data?.warning}" style="min-width: 350px !important;min-height: 200!important;">
  <h1 class="pl-8 pb-0" matDialogTitle>{{data?.title || 'Message Box'}}</h1>
  <div class="pl-8 pb-16" mat-dialog-content>{{data?.message || 'No message specified.  Please click a button to close this message.'}}</div>

  <div *ngIf="data?.showInputField==true" class="pl-12">
    <mat-form-field color="accent" class="w-100-p m-0 form-control">
    <mat-label>{{data?.inputLabel}}</mat-label>
      <input
        id="inputField"
        matInput
        #input
        class="form-control"      
        name="inputField"
        (input)="inputFieldChanged($event)" 
        [setFocus]="data?.showInputField==true"   
      />
    </mat-form-field>
    <label style="display: flex; font-size:small; margin-top: -16px; margin-bottom: 24px;">{{data?.inputHint}}</label>
  </div>
  <div mat-dialog-actions class="pt-12">
    <button *ngIf="!data || (data?.showOkBtn==true)" id="btnOk" [ngClass]="{'bg-red':data?.warning, 'mat-accent': !(data?.warning)}" name="btnOk" mat-raised-button (click)="SetResultAndClose('ok')" [disabled]="(data?.showInputField==true) && (!data?.inputValue)">OK</button>
    <button *ngIf="data?.showYesBtn==true" [ngClass]="{'bg-red':data?.warning, 'mat-accent': !(data?.warning)}" id="btnYes" name="btnYes" mat-raised-button (click)="SetResultAndClose('yes')" [disabled]="(data?.showInputField==true) && (!data?.inputValue)">YES</button>
    <button *ngIf="data?.showNoBtn==true" id="btnNo" name="btnNo" mat-raised-button class="mat-accent" (click)="SetResultAndClose('no')" [setFocus]="data.defaultNo">NO</button>
    <button *ngIf="data?.showConfirmBtn==true" id="btnConfirm" [ngClass]="{'bg-red':data?.warning, 'mat-accent': !(data?.warning)}" name="btnConfirm" mat-raised-button (click)="SetResultAndClose('confirm')">CONFIRM</button>
    <button *ngIf="data?.showCloseBtn==true" id="btnClose" name="btnClose" mat-raised-button class="mat-accent" (click)="SetResultAndClose('close')">CLOSE</button>
    <button *ngIf="data?.showCancelBtn==true" id="btnCancel" name="btnCancel" mat-raised-button class="mat-accent" (click)="SetResultAndClose('cancel')" [setFocus]="data.defaultCancel">CANCEL</button>
  </div>
</div>
